
import request from '@/utils/request';
import Vue from 'vue';
// 创建分类
export function categoryCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visa/category/create`,
      data:params
    });
  }
// 删除 
export function categoryDelete (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visa/category/delete/${params}`
    });
  }
//查询签证分类列表 
export function categoryQuery (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visa/category/query`,
      data:params
    });
  }
  // 修改
export function categoryUpdate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visa/category/update`,
      data:params
    });
  }
//查询国家下面所有的分类
export function getByCountryBid (params) {
    return request({
      method: 'get',
      url: `${Vue.prototype.$conf.visaService}/visa/category/getByCountryBid/${params}`
    });
  }
